import * as conversation from './actions'
import {Map, fromJS, List} from 'immutable';

let initItemState = Map({
        'meta': Map({
            'typing': false,
            'type': '',
            'room': '',
            'info': '',
            'read': Map()
        }),

        'entries': Map({
            'fetching': false,
            'fetched': false,
            'confirmed': List(),
            'unconfirmed': List()
        }),

        'info': Map({
            'payload': Map()
        }),
    })
function conversationItemReducer(state, action) {
    switch (action.type) {

        case conversation.IS_TYPING:
            return state.setIn(['meta', 'typing'], true);
        case conversation.STOP_TYPING:
            return state.setIn(['meta', 'typing'], false);

        case conversation.SET_INFO:
            return state.setIn(['info', 'payload'], fromJS(action.payload))
                        .setIn(['meta', 'room'], action.room);

        case conversation.SET_TYPE:
            return state.setIn(['meta', 'type'], action.conversationType);

        case conversation.SET_META_INFO:
            return state.setIn(['meta', 'info'], action.info);
        case conversation.READ_ENTRIES_REQUEST:
            return state.setIn(['entries', 'fetching'], true)
                        .setIn(['meta', 'room'], action.room);
        case conversation.READ_ENTRIES_SUCCESS:
            if(state.getIn(['entries', 'fetched'])){
                 state = state.updateIn(['entries', 'confirmed'], entries => fromJS(action.entries).concat(entries))
            }else{
                 state = state.setIn(['entries', 'confirmed'], fromJS(action.entries))
            }

            return state.setIn(['entries', 'fetching'], false)
                        .setIn(['entries', 'fetched'], new Date().toLocaleString())

        case conversation.READ_ENTRIES_FAILURE:
            return state.setIn(['entries', 'fetching'], false)
                        .setIn(['entries', 'fetched'], new Date().toLocaleString())

        case conversation.ADD_UNCONFIRMED_ENTRY:
            return state.updateIn(['entries', 'unconfirmed'], entries => entries.push(fromJS(action.entry)))

        case conversation.PUT_CONFIRMED_ENTRIES:
            return state.setIn(['entries', 'confirmed'], fromJS(action.entry))
                        .setIn(['entries', 'fetching'], false)
                        .setIn(['entries', 'fetched'], new Date().toLocaleString())
        case conversation.UPDATE_ENTRY:
            return state.updateIn(['entries', 'confirmed'], entries => {
                return entries.map(entry => {
                    if(entry.get('id') === action.entry.id){
                        return fromJS(action.entry)
                    }
                    return entry
                })
            })
        case conversation.ADD_CONFIRMED_ENTRY:
            return state
                    .updateIn(['entries', 'confirmed'], entries => entries.push(fromJS(action.entry)))
                    .updateIn(['meta', 'read'], mp => mp.map(read => read+=1))
                    .setIn(['meta', 'read', String(action.entry.creator_id)], 0 )
        case conversation.SET_PARTICIPANT_READ:
            return state.setIn(['meta', 'read', action.participantId], 0)
        case conversation.DELETE_TAG_SUCCESS:
        case conversation.CREATE_TAG_SUCCESS:
            return state.setIn(['info', 'payload', 'tag'], action.tags)

        case conversation.SET_ENTRY_TO_CONFIRMED:
            return state
                    .updateIn(['entries', 'unconfirmed'], entries => entries.filter(entry =>
                        {
                            return action.entry.entryRandomId !== entry.get('entryRandomId')
                        })
                    )
                    .updateIn(['entries', 'confirmed'], entries => entries.push(fromJS(action.entry)))
                    .updateIn(['meta', 'read'], mp => mp.map(read => read+=1))
                    .setIn(['meta', 'read', String(action.entry.creator_id)], 0)
        default:
            return state

    }
}


function reducer(
    state=Map({
        items: Map({}),
    }),action)
{
    switch (action.type) {
        case conversation.DELETE_CONVERSATION:
            return state.deleteIn(['items', action.room])
        case conversation.REMOVE_ENTRIES:
            return state.setIn(['items', action.room, 'entries', 'confirmed'], List())
        case conversation.SETS_TYPE:
            action.rooms.map(room => {
                let innerState = state.getIn(['items', room], initItemState)
                innerState = innerState.setIn(['meta', 'type'], action.conversationType)
                state = state.setIn(['items', room], innerState)
                return false;
            })
            return state
        case conversation.SETS_INFO:
            for(var room in action.conversations){
                let innerState = state.getIn(['items', room], initItemState)
                innerState = innerState.setIn(['info', 'payload'], fromJS(action.conversations[room]))
                state = state.setIn(['items', room], innerState)
            }
            return state
        case conversation.SETS_READ:
            for(var roomRead in action.reads){
                let innerState = state.getIn(['items', roomRead], initItemState)
                innerState = innerState.setIn(['meta', 'read'], Map(action.reads[roomRead]))
                state = state.setIn(['items', roomRead], innerState)
            }
            return state
        case conversation.ADD_BULK_ENTRIES:
            for(var room2 in action.entries){
                let innerState = state.getIn(['items', room2], initItemState)
                innerState = innerState.setIn(['entries', 'confirmed'], fromJS(action.entries[room2]))
                innerState = innerState.setIn(['entries', 'fetched'], new Date().toLocaleString())
                state = state.setIn(['items', room2], innerState)
            }
            return state
        case conversation.IS_TYPING:
        case conversation.STOP_TYPING:
        case conversation.PUT_CONFIRMED_ENTRIES:
        case conversation.ADD_CONFIRMED_ENTRY:
        case conversation.ADD_UNCONFIRMED_ENTRY:
        case conversation.SET_ENTRY_TO_CONFIRMED:
        case conversation.READ_ENTRIES_REQUEST: // its a single room here
        case conversation.READ_ENTRIES_SUCCESS:
        case conversation.READ_ENTRIES_FAILURE:
        case conversation.CREATE_TAG_SUCCESS:
        case conversation.CREATE_TAG_FAILURE:
        case conversation.DELETE_TAG_SUCCESS:
        case conversation.SET_INFO:
        case conversation.SET_META_INFO:
        case conversation.SET_TYPE:
        case conversation.SET_PARTICIPANT_READ:
        case conversation.UPDATE_ENTRY:
            var itemPrevState = state.getIn(['items', action.room], initItemState)
            var itemNextState = conversationItemReducer(itemPrevState, action)
            return state.setIn(['items', action.room], itemNextState);
        default:
            return state

    }
}




export default reducer



// WEBPACK FOOTER //
// ./src/model/Conversation/reducer.js